<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M3 13.5L2.25329 13.4298L2.17619 14.25H3V13.5ZM13 13.5V14.25H13.8238L13.7467 13.4298L13 13.5ZM9.75 4.33331C9.75 5.29981 8.9665 6.08331 8 6.08331V7.58331C9.79493 7.58331 11.25 6.12824 11.25 4.33331H9.75ZM8 6.08331C7.0335 6.08331 6.25 5.29981 6.25 4.33331H4.75C4.75 6.12824 6.20507 7.58331 8 7.58331V6.08331ZM6.25 4.33331C6.25 3.36681 7.0335 2.58331 8 2.58331V1.08331C6.20507 1.08331 4.75 2.53839 4.75 4.33331H6.25ZM8 2.58331C8.9665 2.58331 9.75 3.36681 9.75 4.33331H11.25C11.25 2.53839 9.79493 1.08331 8 1.08331V2.58331ZM3.74671 13.5702C3.96018 11.2994 5.63221 9.58331 8 9.58331V8.08331C4.78085 8.08331 2.53174 10.4678 2.25329 13.4298L3.74671 13.5702ZM8 9.58331C10.3678 9.58331 12.0398 11.2994 12.2533 13.5702L13.7467 13.4298C13.4683 10.4678 11.2192 8.08331 8 8.08331V9.58331ZM3 14.25H13V12.75H3V14.25Z"
    fill="currentColor"
  />
</svg>
